import React, {useState, useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {HeaderTitle} from '@/components/atoms';
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable';
import {Header} from '@/utils/constants/header';
import './ProductsTable.scss';

const ProductsTable = (props) => {
  const {
    columns = [],
    records = [],
    isUploadTable = false,
    handleBulkAction = () => {},
    setPageIndex = () => {},
    setSearchArry = () => {},
    searchState = [],
    setSortingObj = () => {},
    pageIndex = 0,
    productListData,
    handleResetAll = () => {},
    isLoading = false,
    setRowSelection,
    rowSelection = [],
    fetchAllProducts,
    initialSortConfig,
    initialSelectedCount = 0,
    isEdit
  } = props;

  const [isSelectAll, setIsSelectAll] = useState(false);

  const toolbarActions = useMemo(() => {
    if (isUploadTable) return [];
    return [
      {
        id: 'include-btn',
        label: 'Include',
        variant: 'secondary',
        color: 'primary',
        requiresSelection: true,
        onClick: async () => {
          await handleBulkAction(
            false,
            fetchAllProducts,
            searchState,
            isSelectAll
          );
        }
      },
      {
        id: 'exclude-btn',
        label: 'Exclude',
        variant: 'secondary',
        color: 'primary',
        requiresSelection: true,
        onClick: async () => {
          await handleBulkAction(
            true,
            fetchAllProducts,
            searchState,
            isSelectAll
          );
        }
      }
    ];
  }, [
    isUploadTable,
    handleBulkAction,
    isSelectAll,
    fetchAllProducts,
    searchState
  ]);

  const onRowSelect = useCallback(
    (selectedRecords, isAll) => {
      setRowSelection(selectedRecords);
      setIsSelectAll(isAll);
    },
    [setRowSelection]
  );

  return (
    <div
      className='productsTable relative px-5'
      style={{backgroundColor: '#1D1D1D'}}
      data-testid='products-table'>
      <HeaderTitle
        headingLevel={Header.SectionTitle}
        title='Select Products to Include or Exclude'
        className='pl-6 pr-4 pt-6 text-lg font-bold'
      />

      <CustomDataTable
        columns={columns}
        records={records || []}
        isLoading={isLoading}
        pageSize={10}
        totalRecords={productListData?.totalRecords || 0}
        paginationConfig={{
          pageIndex,
          setPageIndex
        }}
        sortingConfig={{
          handleSorting: setSortingObj,
          initialSortConfig
        }}
        filterConfig={{
          setSearchArry,
          onResetAll: handleResetAll
        }}
        selectionConfig={{
          onRowSelect,
          isSelectAll,
          initialRowSelection: rowSelection,
          initialSelectedCount,
          disableSelectionPersistence: true,
          isEdit
        }}
        toolbarConfig={{
          toolbarActions
        }}
      />
    </div>
  );
};

ProductsTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  records: PropTypes.arrayOf(PropTypes.object),
  isUploadTable: PropTypes.bool,
  handleBulkAction: PropTypes.func,
  setPageIndex: PropTypes.func,
  setSearchArry: PropTypes.func,
  searchState: PropTypes.array,
  setSortingObj: PropTypes.func,
  pageIndex: PropTypes.number,
  productListData: PropTypes.shape({
    totalRecords: PropTypes.number
  }),
  handleResetAll: PropTypes.func,
  isLoading: PropTypes.bool,
  setRowSelection: PropTypes.func.isRequired,
  rowSelection: PropTypes.array,
  fetchAllProducts: PropTypes.func,
  initialSortConfig: PropTypes.object,
  initialSelectedCount: PropTypes.number
};

export default React.memo(ProductsTable);
